import React, { useState } from "react";

import axios from "axios";
import filesize from "filesize";
import { toastr } from "react-redux-toastr";
import { BounceLoader } from "react-spinners";
import { GreyColor } from "../configs/globals";

export const Attachment = ({ attachment, url, children }) => {
  const [loading, setLoading] = useState(false);

  const downloadFile = () => {
    setLoading(true);

    axios
      .get(url, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", attachment.filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        toastr.error("Wystąpił błąd podczas pobierania pliku");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <button
      className="attachments-list__item"
      title="Kliknij, aby pobrać plik"
      onClick={() => {
        downloadFile({
          file: attachment,
          url: attachment.isAct
            ? `/api/actAttachments/${attachment.id}`
            : `/api/attachments/${attachment.id}`,
        });
      }}
    >
      {loading ? (
        <BounceLoader loading={loading} color={GreyColor} />
      ) : (
        <>{children}</>
      )}

      <div className="attachments-list__name">{attachment.filename}</div>
      <div className="attachments-list__size">
        ({filesize(attachment.size)})
      </div>
    </button>
  );
};
